import Phaser from 'phaser';
import { CST } from '../../../CST';
import { Score } from '../../../controller/score.js';

var pos = 0;

export default class Storyboard_2 extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.STORYBOARD_2);
	}

	init() {
		pos = 0;
	}

	preload() {
		this.load.image('making-memories-bg', 'assets/Storyboards/makingmemories_background.webp');
	}

	create(data) {
		const map = this.add.image(0, 0, 'making-memories-bg').setOrigin(0);

		const cam = this.cameras.main;
		cam.setBounds(0, 0, 4401, 16410); //Left, Top, X Limit, Y Limit
		cam.setZoom(0.35); //0.8
		cam.centerOn(0, 950); //1100, 800

		this.clickSound = this.sound.add('click-sound', {
			volume: 0.5,
		});

		this.score = new Score(this);
		this.User_ID = data.User_ID;

		data.next
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				() => {
					this.clickSound.play();
					pos++;
					data.next.disableInteractive();
					data.previous.disableInteractive();
					setTimeout(() => {
						data.next.setInteractive();
						data.previous.setInteractive();
					}, 1500);
					switch (pos) {
						case -1:
							pos = 0;
							break;
						case 1:
							cam.pan(0, 2400, 1000);
							break;
						case 2:
							cam.pan(1200, 4080, 1000);
							cam.zoomTo(0.7, 1000);
							break;
						case 3:
							cam.pan(3000, 3950, 1000);
							cam.zoomTo(0.55, 1000);
							break;
						case 4:
							cam.pan(1200, 5400, 1000);
							break;
						case 5:
							cam.pan(3025, 5400, 1000);
							cam.zoomTo(0.525, 1000);
							break;
						case 6:
							cam.pan(0, 6900, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 7:
							cam.pan(0, 8300, 1000);
							break;
						case 8:
							cam.pan(1200, 10200, 1000);
							break;
						case 9:
							cam.pan(0, 11500, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 10:
							cam.pan(0, 13400, 1000);
							break;
						case 11:
							pos = 0;
							data.next.setVisible(false);
							data.previous.setVisible(false);
							data.pause.setVisible(false);
							this.scene.resume(CST.SCENES.MAIN_QUESTIONS, {
								User_ID: this.User_ID,
								story: 2,
							});
							this.scene.stop();
							break;
					}
				},
				this,
			);

		data.previous
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				() => {
					this.clickSound.play();
					pos--;
					data.next.disableInteractive();
					data.previous.disableInteractive();
					setTimeout(() => {
						data.next.setInteractive();
						data.previous.setInteractive();
					}, 1500);
					switch (pos) {
						case -1:
							pos = 0;
							break;
						case 0:
							cam.pan(0, 950, 1000);
							break;
						case 1:
							cam.pan(0, 2400, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 2:
							cam.pan(1200, 4080, 1000);
							cam.zoomTo(0.8, 1000);
							break;
						case 3:
							cam.pan(3000, 3950, 1000);
							break;
						case 4:
							cam.pan(1200, 5400, 1000);
							break;
						case 5:
							cam.pan(3000, 5400, 1000);
							cam.zoomTo(0.55, 1000);
							break;
						case 6:
							cam.pan(0, 6900, 1000);
							break;
						case 7:
							cam.pan(0, 8300, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 8:
							cam.pan(1200, 10200, 1000);
							break;
						case 9:
							cam.pan(0, 11500, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 10:
							cam.pan(0, 13400, 1000);
							break;
					}
				},
				this,
			);
	}
}
